import React, { useCallback, useEffect } from 'react'

import { showErrorNotification } from '../../../core/helpers'
import { useQueryParams } from '../../../core/hooks'

import { Page } from '../../../common/components/sections'
import {
  StyledPageHeader,
  StyledPageTitle,
} from '../../../common/components/styled'
import { APP_ROUTES, PAGINATION } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { useLoggedInUser } from '../../../account/hooks'
import {
  useCreatePriorityTaskMutation,
  usePriorityTasksQuery,
} from '../../hooks'
import { transformPriorityTaskToCreateArgs } from '../../transformers'
import { PriorityTaskCreateForm } from '../forms'
import { PriorityTasksTable } from '../sections'

const PriorityTasksPage = () => {
  useDocumentTitle(APP_ROUTES.MISC.children.PRIORITY_TASKS.label)
  const { settings: userSettings } = useLoggedInUser()

  const {
    currentPage = PAGINATION.DEFAULT_PAGE,
    pageSize = userSettings?.pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
  } = useQueryParams()

  const {
    data,
    isLoading: isFetchLoading,
    error: fetchError,
  } = usePriorityTasksQuery({
    currentPage,
    pageSize,
  })
  const { result: priorityTasks, total } = data || {}

  const [
    createPriorityTask,
    { isLoading: isCreateLoading, error: createError },
  ] = useCreatePriorityTaskMutation()

  const handleCreatePriorityTask = useCallback(
    data => createPriorityTask(transformPriorityTaskToCreateArgs(data)),
    [createPriorityTask],
  )

  useEffect(() => {
    if (createError) {
      showErrorNotification({
        title: 'Task create failed',
        description: createError,
      })
    }
  }, [createError])

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Fetch priority tasks failed',
        description: fetchError,
      })
    }
  }, [fetchError])

  return (
    <Page>
      <StyledPageHeader>
        <StyledPageTitle>Priority tasks</StyledPageTitle>
      </StyledPageHeader>
      <PriorityTaskCreateForm
        onSubmit={handleCreatePriorityTask}
        isLoading={isCreateLoading}
      />
      <PriorityTasksTable
        isLoading={isFetchLoading}
        tasks={priorityTasks}
        total={total}
      />
    </Page>
  )
}

export default PriorityTasksPage
